class PromiseCancellationError extends Error {
  constructor(...args) {
    super(...args);
    this.isCancelled = true;
  }
}

// eslint-disable-next-line import/prefer-default-export
export function makeCancellable(promise) {
  let hasCancelled = false;
  const wrappedPromise = new Promise((resolve, reject) => {
    promise.then(val => hasCancelled ? reject(new PromiseCancellationError()) : resolve(val), error => hasCancelled ? reject(new PromiseCancellationError()) : reject(new Error(error)));
  });
  wrappedPromise.cancel = () => {
    hasCancelled = true;
  };
  return wrappedPromise;
}